var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "openmoji:two-oclock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99063 13.1089C10.8134 13.1089 13.1017 10.8206 13.1017 7.99783C13.1017 5.17504 10.8134 2.88672 7.99063 2.88672C5.16784 2.88672 2.87952 5.17504 2.87952 7.99783C2.87952 10.8206 5.16784 13.1089 7.99063 13.1089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 4.21973V7.9975V4.21973ZM10.2349 6.71239L8.01267 7.9955L10.2349 6.71239Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.99063 13.1089C10.8134 13.1089 13.1017 10.8206 13.1017 7.99783C13.1017 5.17504 10.8134 2.88672 7.99063 2.88672C5.16784 2.88672 2.87952 5.17504 2.87952 7.99783C2.87952 10.8206 5.16784 13.1089 7.99063 13.1089Z",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8 4.21973V7.9975M10.2349 6.71239L8.01267 7.9955",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.8697e05792d64fe3baaabbfbfb69c70f.svg";
export { ForwardRef as ReactComponent };